export default function({ app, store }) {
  app.router.beforeEach(async (to, from, next) => {
    // Skip for login and upsell routes
    if (to.name?.includes('upsell') || !to.name?.includes('dashboard')) {
      return next();
    }

    try {
      const ssidCheck = await app.$http.$get(
        `${window.location.origin}/dashboard/ssid-check`
      );

      if (!ssidCheck.authenticated) {
        // Dispatch logout action - Only If user object is not empty
        if (
          store.state?.auth?.currentUser &&
          Object.keys(store.state.auth.currentUser).length > 0
        ) {
          await store.dispatch('auth/logout');
        }

        window.location.href = '/login?sessionTimeout=true';
        return;
      }
    } catch (error) {
      console.error('Auth Guard - SSID check failed:', error);
      if (
        store.state?.auth?.currentUser &&
        Object.keys(store.state.auth.currentUser).length > 0
      ) {
        await store.dispatch('auth/logout');
      }
      window.location.href = '/login?sessionTimeout=true';
      return;
    }

    next();
  });
}
